<template>
  <div class="type-container">
    <!-- 账号类型选择区域 -->
    <div class="type-selection">
      <!-- 会员注册 -->
      <div class="type-card" :class="{ loading: loading }" @click="selectType('member')">
        <img src="@/assets/image/sf1.png" alt="会员注册">
        <div v-if="loading" class="loading-overlay">
          <i class="el-icon-loading" />
        </div>
      </div>

      <!-- 造价师注册 -->
      <div class="type-card" :class="{ loading: loading }" @click="selectType('engineer')">
        <img src="@/assets/image/sf2.png" alt="造价师注册">
        <div v-if="loading" class="loading-overlay">
          <i class="el-icon-loading" />
        </div>
      </div>

      <!-- 供应商注册 -->
      <div class="type-card" :class="{ loading: loading }" @click="selectType('supplier')">
        <img src="@/assets/image/sf3.png" alt="供应商注册">
        <div v-if="loading" class="loading-overlay">
          <i class="el-icon-loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { selectUserType } from '@/api/user'

export default {
  name: 'Type',
  data() {
    return {
      loading: false
    }
  },
  methods: {
    selectType(type) {
      // 防止重复点击
      if (this.loading) return

      let groupId
      let routePath
      // 根据选择的类型设置对应的group_id和路由
      switch (type) {
        case 'member':
          groupId = 1 // 会员
          routePath = '/'
          break
        case 'engineer':
          groupId = 2 // 造价师
          routePath = '/engineer'
          break
        case 'supplier':
          groupId = 3 // 供应商
          routePath = '/supplier'
          break
        default:
          return
      }

      this.loading = true

      // 调用选择用户类型接口
      const data = {
        group_id: groupId
      }

      selectUserType(data).then(response => {
        this.loading = false
        if (response.code === 1) {
          // 接口调用成功，跳转到对应页面
          this.$message.success('选择成功')
          this.$router.push(routePath)
        } else {
          // 接口返回错误
          this.$message.error(response.msg || '选择失败')
        }
      }).catch(error => {
        this.loading = false
        console.error('选择用户类型失败:', error)
        this.$message.error('选择失败，请重试')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.type-container {
  min-height: 100vh;
  width: 100%;
  background: url('~@/assets/image/bg2.png') center/cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.type-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 40px;

  .type-card {
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:hover:not(.loading) {
      transform: translateY(-10px);
    }

    &.loading {
      cursor: not-allowed;
      opacity: 0.7;
    }

    img {
      width: 300px;
      height: 535px;
      object-fit: contain;
    }

    .loading-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 0.8);
      border-radius: 50%;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 24px;
        color: #409EFF;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .type-selection {
    gap: 30px;
    padding: 30px;

    .type-card img {
      width: 180px;
      height: 180px;
    }
  }
}

@media (max-width: 768px) {
  .type-container {
    padding: 20px;
  }

  .type-selection {
    flex-direction: column;
    gap: 20px;
    padding: 20px;

    .type-card img {
      width: 150px;
      height: 150px;
    }
  }
}
</style>
